export default __webpack_public_path__ + "images/RVOT.27013d5e23eb8fc156a407b27c87f474.png";